import { Component, OnInit } from '@angular/core';
import { NewsService } from '../news.service';
import { Router } from '@angular/router';
 

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css'],
  providers:[ NewsService ]
})
export class NewsComponent implements OnInit {

  
	news: any[];
  loading: boolean = false;
  searchFilter: any = [];
  searchColumn: any = [];

  constructor(
              private newsService: NewsService,
              private router: Router) { }

  ngOnInit() {
    this.fillSearchColumn();
    this.loading = true;
    this.newsService.getNews().subscribe(response=>{ this.news = response['data'];this.loading = false;})
  }
  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Название", value: { column: "title", type: "textbox" } });
  }
  setFilter(data){
    this.searchFilter=data;
    this.loading = true;
    this.newsService.getNewsByFilter(this.searchFilter).subscribe(response=>{ this.news = response['data']; this.loading = false;});
  }


  add():void {
    this.router.navigate(['dashboard/news-crud']);
  }  

  edit(id: any){
     this.router.navigate(['dashboard/news-crud/',id]);
  }


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/news/news/news.component.ts